/**
 * Emissions Tracker Route Matcher
 *
 * Filters initiatives to only show orgs with an active/trialing emission_tracker subscription.
 */

import { AppRootMatcher } from '@routes/appRootMatcher';
import { generateUrl } from '@routes/util';
import { emissionsTrackerRoutes, rootAppPath } from './routes';
import { ProductCodes } from '../../types/products';
import { SubscriptionService } from '../../services/SubscriptionService';
import { AppIds } from '@utils/permission-groups';
import { AppCode } from '../../types/app';

export const emissionsTrackerRouteMatcher: AppRootMatcher = {
  storageKey: AppIds.EmissionsTracker,
  filterInitiatives: (initiatives) =>
    initiatives.filter((r) =>
      SubscriptionService.hasActiveOrTrialing(ProductCodes.EmissionTracker, r.calculatedSubscriptions)  || r.appConfig?.code === AppCode.EmissionTracker
    ),
  generateUrl: (id: string) =>
    generateUrl(emissionsTrackerRoutes.EMISSIONS_OVERVIEW, {
      rootAppPath,
      initiativeId: id,
    }),
};
